import React, { useState } from "react";
import PT from "prop-types";
import { parseUrl } from "query-string";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Button } from "../../atoms/button";
import { InputField } from "../../atoms/input-field";
import { register, checkForMemberInFirebase, getUser } from "../../helper/api";
import wretch from "wretch";
import "./forms.m.css";

export function SignUp({ onSignup }) {
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    password: "",
    mobile: ""
  });
  const [errorMsg, setError] = useState("");
  const currentPath = useSelector(state => get(state, ["qt", "currentPath"], ""));
  const sketchesHost = useSelector(state => get(state, ["qt", "currentHostUrl"], "https://newslaundry.com"));
  const authHost = useSelector(state => get(state, ["qt", "config", "publisher", "publisher", "auth_host"], null));
  const params = parseUrl(currentPath);
  const redirectUrl = get(params, ["query", "redirect-url"], sketchesHost);
  const callbackUrl = get(params, ["query", "callback-url"], sketchesHost);

  // const sendEmail = user => {
  //   const data = {
  //     event: "signup",
  //     mail: user.email,
  //     name: user.name
  //   };
  //   wretch("/send-email").post(data);
  // };

  const signUpHandler = async e => {
    e.preventDefault();
    e.stopPropagation();
    const userObj = {
      name: userInfo.name,
      email: userInfo.email,
      username: userInfo.email,
      password: userInfo.password,
      "dont-login": false
    };

    const user = () => {
      getUser()
        .then(response => {
          onSignup(response.member);
          checkForMemberInFirebase(response.member);
        })
        .catch(ex => console.log(ex.message));
    };

    register(userObj, callbackUrl, redirectUrl, authHost)
      .then(response => {
        user();
        // sendEmail(user);
      })
      .catch(err => {
        if (err.status === 409) {
          setError(`The email '${userObj.email}' already exists`);
        } else {
          setError("Oops! Something went wrong");
        }
      });
  };
  const setData = e => {
    const userObj = { ...userInfo };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUserInfo(userObj);
  };

  return (
    <form styleName="nl-form" onSubmit={signUpHandler}>
      <InputField name="Name" id="name" required onChange={setData} />
      {/* <InputField
        name="Mobile Number"
        type="tel"
        id="mobile"
        maxLength="10"
        pattern="^\d{10}$"
        onChange={setData}
        required
      /> */}
      <InputField name="Email" type="email" id="email" onChange={setData} required />
      <InputField name="Password" type="password" id="password" onChange={setData} required />
      {errorMsg && <p styleName="error">{errorMsg}</p>}
      <Button onClick={signUpHandler} className="nl-btn-large nl-btn-right">
        Sign up
      </Button>
    </form>
  );
}

SignUp.propTypes = {
  onSignup: PT.func,
  setMember: PT.func
};
